import { memo } from "react";
import CourseBanner from "./courses/courseBanner";
import CoursesCard from "./courses/coursesCards";
import CoursesSkeleton from "./CoursesSkeleton";
import type { CoursesState } from "../hooks/useCourses";

export type CoursesProps = CoursesState;

const Spinner = ({ size = "sm" }: { size?: "sm" | "lg" }) => (
  <div
    className={`spinner-border text-red spinner-border-${size} m-2`}
    role="status"
  >
    <span className="visually-hidden">Loading...</span>
  </div>
);

const Courses = ({
  isLoading,
  categories,
  courses,
  grades,
  subjects,
  videos,
  categoryId,
  courseId,
  gradeId,
  subjectId,
  courseName,
  loader,
  token,
  refresh,
  onCategoryChange,
  onTypeChange,
  onGradeChange,
  onSubjectChange,
}: CoursesProps) => {
  if (isLoading) {
    return <CoursesSkeleton />;
  }

  return (
    <>
      <CourseBanner
      heading="Courses"
      desc="Get these courses for FREE & Learn something new today"
    />
    <div className="w-100 my-5">
      <div className="container-xxl">
        <div className="row">
          <div className="col-12">
            <h3>Search Video lectures</h3>
          </div>

          <div className="col-12 col-sm-4 my-3">
            <label> Categories </label>
            <select
              className="form-select mt-2"
              value={categoryId}
              onChange={onCategoryChange}
            >
              <option value="-2">Select Category</option>
              {categories.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.title}
                </option>
              ))}
              <option value="-1">Grades</option>
              <option value="-3">Test Preparation</option>
            </select>
          </div>

          {(categoryId > -1 && categoryId) || categoryId === -3 ? (
            <div className="col-12 my-3 col-sm-4">
              <label> Type</label>
              <select
                className="form-select mt-2"
                value={courseId}
                onChange={onTypeChange}
              >
                <option value="-2">Select Type</option>
                {courses.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>
          ) : null}

          {categoryId < 0 && categoryId > -2 ? (
            <div className="col-12 my-3 col-sm-4">
              <label> Grade</label>
              <select
                className="form-select mt-2"
                value={gradeId}
                onChange={onGradeChange}
              >
                <option value="-2">Select Grade</option>
                {grades.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>
          ) : null}

          {subjects.length === 0 && categoryId === -1 && gradeId > -1 ? (
            <div className="col-12 col-sm-4 my-3 d-flex justify-content-center align-items-start flex-column">
              <div className="mt-4">
                <Spinner />
              </div>
            </div>
          ) : categoryId === -1 && gradeId > -1 ? (
            <div className="col-12 my-3 col-sm-4">
              <label> Subjects</label>
              <select
                className="form-select mt-2"
                value={subjectId}
                onChange={onSubjectChange}
              >
                <option value="-2">Select Subject</option>
                {subjects.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.subject.title}
                  </option>
                ))}
              </select>
            </div>
          ) : null}
        </div>

        <div className="row my-4">
          {videos.length === 0 ? (
            <div className="col-12 text-center">
              <p className="text-red">No Record Found</p>
            </div>
          ) : loader ? (
            <div className="col-12 text-center">
              <Spinner size="lg" />
            </div>
          ) : (
            videos.map((item) => (
              <div
                className="col-12 col-sm-6 col-md-4 my-3 col-lg-3"
                key={item.id}
              >
                <CoursesCard
                  data={item}
                  courseId={subjectId > -2 ? subjectId : courseId}
                  refresh={refresh}
                  courseName={courseName}
                  token={token}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default memo(Courses);
